import { render, staticRenderFns } from "./publicList.vue?vue&type=template&id=9dc2c842&"
import script from "./publicList.vue?vue&type=script&lang=js&"
export * from "./publicList.vue?vue&type=script&lang=js&"
import style0 from "./publicList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports